module.exports = __webpack_public_path__ + "img/1082one1.e412aded.png";